export const DOT_WIDTH = 16;
export const DOT_HEIGHT = 16;
export const DOT_RADIUS = 8;
export const INNER_CIRCLE_RADIUS = 2.5;
export const DOT_OFFSET = 8;

export const INSURANCE_CLAIMS_CHART_CONFIG = {
  innerRadius: 38,
  outerRadius: 55,
  paddingAngle: 2,
  startAngle: 90,
  endAngle: -270,
};

export const PERFERRED_PAYMENT_METHOD_CHART_CONFIG = {
  innerRadius: 38,
  outerRadius: 55,
  paddingAngle: 2,
  startAngle: 90,
  endAngle: -270,
};

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const windowSize = 8;
